<div class="pull-right comment-text-box-content-length" *ngIf="value">
    {{ maxLength - value.length }}
</div>
